import React from 'react';
import classNames from 'classnames';

import './Checkbox.scss';

export default function Checkbox({
	name,
	id = name,
	label,
	errorMessage,
	validationMessage,
	required,
	disabled = false,
	styles,

	checkedValue = true,

	// uncontrolled
	defaultValue,

	// controlled
	value,
	onChange,

	children,
}) {
	return (
		<div className="Checkbox formElement Checkbox--light checkbox-custom " style={styles}>
			<input
				className={classNames('Checkbox-input formElement-field ', {
					'formElement-field--invalid': errorMessage,
				})}
				type="checkbox"
				id={id}
				name={name}
				defaultValue={defaultValue}
				required={required}
				disabled={disabled}
				data-error-message={errorMessage}
				data-validation-message={validationMessage}
				checked={value === checkedValue}
				onChange={onChange}
				value={checkedValue}
			/>

			<label className="Checkbox-decoration" htmlFor={id} aria-hidden="true" role="presentation" />

			<div>
				<label className="Checkbox-label ty-b2" htmlFor={id}>
					{children || label}
				</label>

				{typeof errorMessage === 'string' && errorMessage.length > 0 && (
					<div
						className="formElement-message formElement-field--invalid checkbox-custom__error-message"
						role="alert"
					>
						{errorMessage}
					</div>
				)}
			</div>
		</div>
	);
}
